<template>
    <div class="header-auth">
        <div class="header-auth__content">
            <div></div>
            <div class="header-auth__btn-container">
                <div class="header-auth__btn-title">{{title}}</div>
                <!-- <div>
                    <router-link 
                        :to="href" 
                        class="header-authr__btn_action"
                    >
                        {{buttonText}}
                    </router-link>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HeaderAuth",
    /**
     * Входные параметры
     * @property {string} title - заголовок
     * @property {string} href - ссылка
     * @property {string} buttonText - текст
     */
    props: {
        title: {
            type: String,
            default: ""
        },
        href: {
            type: String,
            default: ""
        },
        buttonText: {
            type: String,
            default: ""
        }
    }
}
</script>

<style lang="scss" scoped>
    .header-auth {
        width: 100%;
        height: 100%;
    }
    %header-auth-flex-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .header-auth__content {
        @extend %header-auth-flex-container;
    }
    .header-auth__btn-container {
        @extend %header-auth-flex-container;
        padding: 20px 20px 0 0
    }
    .header-auth__btn-title {
        margin: 0 40px 0 90px;
        white-space: nowrap;
    }
    .header-authr__btn_action {
        border: 1px solid #2686e6;
        color: #2686e6;
        padding: 5px 15px;
        border-radius: 4px;
        transition: all 250ms;
        text-decoration: none;
    }
    .header-authr__btn_action:hover {
        background: #2686e6;
        color: #fff;
    }
</style>